interface IThemeCategories {
	id: number;
	name: string;
}

interface IThemeTags {
	name: string;
	slug: string;
}

export interface IPremadeQuiz {
	uuid: string;
	title: string;
	created_at: number;
	short_description: string;
	long_description: string;
	cover_photo: string;
	cover_photo_small: string;
	play_cover_photo: string;
	author: {
		display_name: string;
		display_name_slug?: string;
		author_cover_photo?: string;
		author_description?: string;
	};
	price?: string;
	level: 0 | 1 | 2 | 3;
	section?: string;
	subcategories?: IThemeCategories[];
	primary_thematic_tags?: IThemeTags[];
	answers_template?: string | null;
	number_of_questions: number;
	section_order?: number;
	puzzle?: boolean;
	puzzle_answer?: string;
	for_kids?: boolean;
	playlist_url?: string;
	chapters?: [
		{
			title: string;
			description?: string;
			alternate_description?: string;
			chapter_start: number;
			chapter_end: number;
		},
	];
}

export class IPremadeQuiz {
	constructor(object?: Partial<IPremadeQuiz>) {
		this.uuid = object?.uuid || '';
		this.title = object?.title || '';
		this.short_description = object?.short_description || '';
		this.long_description = object?.long_description || '';
		this.cover_photo = object?.cover_photo || '';
		this.cover_photo_small = object?.cover_photo_small || '';
		this.play_cover_photo =
			object?.play_cover_photo || object?.cover_photo || '';
		this.price = object?.price || '0.00';
		this.level = object?.level || 0;
		this.author = object?.author || {
			display_name: '',
			display_name_slug: '',
			author_cover_photo: '',
			author_description: '',
		};
		this.subcategories = object?.subcategories || [{ id: 0, name: '' }];
		this.primary_thematic_tags = object?.primary_thematic_tags || [
			{ name: '', slug: '' },
		];
		this.answers_template = object?.answers_template || null;
		this.number_of_questions = object?.number_of_questions || 0;
		this.section_order = object?.section_order || 0;
		this.puzzle = object?.puzzle || false;
		this.puzzle_answer = object?.puzzle_answer || '';
		this.for_kids = object?.for_kids || false;
	}
}

export interface IUserQuizzes {
	fresh: boolean;
	uuid: string;
	created_at: number;
	number_of_questions: number;
	quiz_type: string;
	premade_quiz?: IPremadeQuiz | null;
}

export class IUserQuizzes {
	constructor(object?: Partial<IUserQuizzes>) {
		this.fresh = object?.fresh || false;
		this.uuid = object?.uuid || '';
		this.created_at = object?.created_at || 0;
		this.number_of_questions = object?.number_of_questions || 1;
		this.quiz_type = object?.quiz_type || 'quick';
		this.premade_quiz = object?.premade_quiz || null;
	}
}

export type QuizMode = 'qqaa' | 'qaqa';

export interface UserQuizzesOutletContextType {
	quizzesToList: IUserQuizzes[];
	authoredQuizzesToList: IUserQuizzes[];
	loading: boolean;
}

export enum ReportIssueState {
	submitting = 'submitting',
	submitted = 'submitted',
}

interface StepRoute {
	prev: string;
	current: string;
	next: string;
	type:
		| 'question'
		| 'answer'
		| 'break'
		| 'chapter'
		| 'question-chapter'
		| 'question-chapter-end'
		| 'answer-chapter'
		| 'answer-chapter-end';
}
export type StepRouteMap = Record<number, StepRoute>;
